var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeWhatsapp = function SvgCassiopeiaBadgeWhatsapp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg7957",
    width: 34.488,
    height: 34.488,
    viewBox: "0 0 9.125 9.125",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(254.063 -62.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8812",
    transform: "matrix(.0263 0 0 .0263 -240.914 79.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g21495",
    style: {
      strokeWidth: 10.0633,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(314.093 115.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path19606",
    d: "m-105.495 103.127-58.43 277.144 105.83-63.291V103.127Z",
    style: {
      fill: "#d4a400",
      fillOpacity: 1,
      stroke: "#5f4a03",
      strokeWidth: 10.0633,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19606-6",
    d: "m-10.693 103.127 58.43 277.144-105.831-63.291V103.127Z",
    style: {
      fill: "#ffbe00",
      fillOpacity: 1,
      stroke: "#987102",
      strokeWidth: 10.0633,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path19606-2",
    d: "M-227.762 63.52c-.18 0-.361.105-.421.317a.438.438 0 0 1-.764.153c-.274-.346-.829-.116-.778.322a.437.437 0 0 1-.647.432c-.385-.214-.81.21-.596.596a.438.438 0 0 1-.433.647c-.437-.05-.667.504-.322.778a.438.438 0 0 1-.152.764c-.423.12-.423.721 0 .842a.437.437 0 0 1 .152.764c-.345.273-.115.828.322.777a.438.438 0 0 1 .433.648c-.214.385.21.81.596.595a.438.438 0 0 1 .647.433.424.424 0 0 0 .114.35l-.927 4.393 2.783-1.664 2.782 1.664-.929-4.406a.424.424 0 0 0 .102-.337.438.438 0 0 1 .648-.433c.385.215.81-.21.595-.595a.437.437 0 0 1 .433-.648c.437.051.667-.504.322-.777a.438.438 0 0 1 .152-.764c.424-.12.424-.721 0-.842a.438.438 0 0 1-.152-.764c.345-.274.115-.829-.322-.778a.437.437 0 0 1-.433-.647c.215-.385-.21-.81-.595-.596a.437.437 0 0 1-.648-.432c.051-.438-.504-.668-.777-.322a.438.438 0 0 1-.765-.153.428.428 0 0 0-.42-.317z",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 0.5,
      stroke: "#000",
      strokeWidth: 0.264583,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: ".79375,.264583",
      strokeDashoffset: 0.396875,
      strokeOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8747",
    d: "M-249.08 62.592a.438.438 0 0 0 .765.152c.273-.345.828-.115.777.322a.438.438 0 0 0 .648.433c.385-.214.81.21.595.595a.438.438 0 0 0 .433.648c.438-.05.668.504.322.778a.438.438 0 0 0 .152.764c.424.12.424.72 0 .841a.438.438 0 0 0-.152.764c.346.274.116.829-.322.778a.438.438 0 0 0-.433.648c.215.385-.21.81-.595.595a.438.438 0 0 0-.648.433c.051.437-.504.667-.777.322a.438.438 0 0 0-.764.152c-.12.424-.722.424-.842 0a.438.438 0 0 0-.764-.152c-.274.345-.829.115-.778-.322a.438.438 0 0 0-.647-.433c-.385.214-.81-.21-.596-.595a.438.438 0 0 0-.432-.648c-.438.05-.668-.504-.323-.778a.438.438 0 0 0-.152-.764c-.423-.12-.423-.72 0-.841a.438.438 0 0 0 .152-.764c-.345-.274-.115-.829.323-.778a.438.438 0 0 0 .432-.648c-.214-.385.21-.81.596-.595a.438.438 0 0 0 .647-.433c-.05-.437.504-.667.778-.322.221.28.666.191.764-.152.12-.424.721-.424.842 0z",
    style: {
      fill: "#18ea66",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264584,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g31505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8747-6",
    d: "M-247.89 62.5a.424.424 0 0 0-.346.166.449.449 0 0 1-.08.078 7.547 6.854 0 0 1 .08.989 7.547 6.854 0 0 1-4.17 6.126.425.425 0 0 0 .375-.027.437.437 0 0 1 .647.433c-.05.437.504.668.778.322a.437.437 0 0 1 .764.152c.12.424.72.424.841 0a.438.438 0 0 1 .765-.152c.273.346.828.115.777-.322a.437.437 0 0 1 .648-.433c.385.215.81-.21.595-.595a.437.437 0 0 1 .433-.648c.437.051.668-.504.322-.777a.437.437 0 0 1 .152-.764c.424-.12.424-.721 0-.842a.438.438 0 0 1-.152-.764c.346-.274.115-.829-.322-.778a.437.437 0 0 1-.433-.648c.215-.384-.21-.81-.595-.595a.437.437 0 0 1-.648-.432.437.437 0 0 0-.432-.49z",
    style: {
      fill: "#16b116",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264583,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8158",
    style: {
      fill: "#000"
    },
    transform: "matrix(.34366 0 0 .34366 -252.117 63.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8146",
    d: "M11.42 9.49c-.19-.09-1.1-.54-1.27-.61-.17-.07-.29-.09-.42.1s-.48.6-.59.73c-.11.13-.21.14-.4 0a5.13 5.13 0 0 1-1.49-.92 5.25 5.25 0 0 1-1-1.29c-.11-.18 0-.28.08-.38.08-.1.18-.21.28-.32a1.39 1.39 0 0 0 .18-.31.38.38 0 0 0 0-.33c0-.09-.42-1-.58-1.37-.16-.37-.3-.32-.41-.32h-.4a.72.72 0 0 0-.5.23 2.1 2.1 0 0 0-.65 1.55A3.59 3.59 0 0 0 5 8.2 8.32 8.32 0 0 0 8.19 11c.44.19.78.3 1.05.39a2.53 2.53 0 0 0 1.17.07 1.93 1.93 0 0 0 1.26-.88 1.67 1.67 0 0 0 .11-.88c-.05-.07-.17-.12-.36-.21Z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8148",
    d: "M13.29 2.68A7.36 7.36 0 0 0 8 .5a7.44 7.44 0 0 0-6.41 11.15l-1 3.85 3.94-1a7.4 7.4 0 0 0 3.55.9H8a7.44 7.44 0 0 0 5.29-12.72ZM8 14.12a6.12 6.12 0 0 1-3.15-.87l-.22-.13-2.34.61.62-2.28-.14-.23a6.18 6.18 0 0 1 9.6-7.65 6.12 6.12 0 0 1 1.81 4.37A6.19 6.19 0 0 1 8 14.12Z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path8747-7",
    d: "M-249.08 62.592a.438.438 0 0 0 .765.152c.273-.345.828-.115.777.322a.438.438 0 0 0 .648.433c.385-.214.81.21.595.595a.438.438 0 0 0 .433.648c.438-.05.668.504.322.778a.438.438 0 0 0 .152.764c.424.12.424.72 0 .841a.438.438 0 0 0-.152.764c.346.274.116.829-.322.778a.438.438 0 0 0-.433.648c.215.385-.21.81-.595.595a.438.438 0 0 0-.648.433c.051.437-.504.667-.777.322a.438.438 0 0 0-.764.152c-.12.424-.722.424-.842 0a.438.438 0 0 0-.764-.152c-.274.345-.829.115-.778-.322a.438.438 0 0 0-.647-.433c-.385.214-.81-.21-.596-.595a.438.438 0 0 0-.432-.648c-.438.05-.668-.504-.323-.778a.438.438 0 0 0-.152-.764c-.423-.12-.423-.72 0-.841a.438.438 0 0 0 .152-.764c-.345-.274-.115-.829.323-.778a.438.438 0 0 0 .432-.648c-.214-.385.21-.81.596-.595a.438.438 0 0 0 .647-.433c-.05-.437.504-.667.778-.322.221.28.666.191.764-.152.12-.424.721-.424.842 0z",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#187d18",
      strokeWidth: 0.264583,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style8018",
    type: "text/css"
  }, ".st0{fill:#000}")));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeWhatsapp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-whatsapp.7d53c25f0fd862dca107b6e9e382c5d3.svg";